<template>
  <v-container :class="['pa-0', $style.fullHeight]" grid-list-sm>
    <v-layout row align-center justify-center :class="$style.fullHeight">
      <v-responsive height="100%" max-width="100%">
        <div :class="$style.contentWrapper">
          <v-layout justify-center align-center>
            <span>{{ lang.end_content }}</span>
          </v-layout>
          <v-layout justify-center align-center>
            <div
              :class="[
                $style.conductorContetnsLinkItem,
                reactionButtonFontSize,
                'd-inline-block',
                $style.closeButton
              ]"
              @click="onClickCloseColophon()"
            >
              <span v-if="isVertical">{{ lang.close_vertical_contents }}</span>
              <span v-else>{{ lang.close }}</span>
            </div>
          </v-layout>
          <v-layout v-if="displayLinkUrl" justify-center align-center>
            <vc-share-a
              :href="displayLinkUrl"
              :target="linkWithTargetBlank ? '_blank' : '_top'"
              style="text-decoration: none; width: 100%;"
            >
              <span :class="$style.navioText"> {{ linkText }} </span>
            </vc-share-a>
          </v-layout>
        </div>
      </v-responsive>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "vc-share-vertical-contents-colophon",
  props: {
    isPreview: {
      type: Boolean,
      default: null
    },
    contentUrl: {
      type: String,
      default: ""
    },
    contentShareUrl: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    linkUrl: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: ""
    },
    // SHARE-473 の対策で、Twitterクライアント内で同窓遷移となるよう奥付内のリンクには原則 target='_top' を指定しているが、
    // 一部ブラウザにてリンクが期待動作しない( SHARE-534 )ため、本フラグを用いてUA判定によるリンクの出し分けを行う
    linkWithTargetBlank: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => {
        return {
          close: "もういちど読む",
          end_content: "この作品はここまでです。",
          title: "奥付"
        };
      }
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    isWallPage: {
      type: Boolean,
      default: false
    },
    readerApplicationUriBase: {
      type: String,
      default: ""
    },
    displayContentTopLink: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      reactionButtonFontSize: "body-2",
      contentTop: this.isPreview ? "" : this.contentUrl,
      displayLinkUrl: this.isPreview ? "" : this.linkUrl
    };
  },
  mounted: function() {
    switch (this.locale) {
      case "es-es":
        this.reactionButtonFontSize = "body-1";
        break;
      case "de-de":
        this.reactionButtonFontSize = "body-1";
        break;
      default:
        break;
    }

    // iOSで奥付けを表示したときにドラッグ、拡大・縮小を無効にする
    if (this.isVertical) {
      document.addEventListener(
        "touchstart",
        event => {
          if (event.touches.length >= 2) {
            event.preventDefault();
          }
        },
        { passive: false }
      );
    } else {
      document.addEventListener(
        "touchmove",
        event => {
          event.preventDefault();
        },
        { passive: false }
      );
    }

    let dummyLinks = document.getElementsByClassName("dummy");
    for (let dummyLink of dummyLinks) {
      dummyLink.onclick = function() {
        return false;
      };
    }
  },
  methods: {
    onClickCloseColophon() {
      if (this.isPreview) {
        return;
      }

      if (!this.isVertical) {
        window.parent.postMessage("first_page", this.readerApplicationUriBase);
        return;
      }

      if (this.isVertical) {
        if (this.linkWithTargetBlank) {
          window.open(this.contentTop, "_blank");
        } else {
          top.window.location.href = this.contentTop;
        }
      }
    }
  }
};
</script>

<style module>
.contentWrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
}

.closeButton {
  border-radius: 48px;
  border-style: solid;
  border-color: #1976d2;
  padding: 8px 24px;
  cursor: pointer;
}

.conductorContetnsLinkItem {
  white-space: normal;
  word-break: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  vertical-align: middle;
}

.fullHeight {
  height: 100%;
}

.navioText {
  font-size: 16px;
  text-align: left;
}
</style>
